<template>
  <section class="section">
    <div class="container">
      <h1>This is an test page</h1>
      <h1 class="title">Подаци о поруџбини</h1>
      <div class="box">
        <h3 class="is-size-5">Дирекција за изградњу</h3>
        <h3 class="is-size-5">Број поруџбине:</h3>
        <h3 class="is-size-5">Износ и валута: {{ iznos }} {{ valuta }}</h3>
      </div>

      <div class="buttons">
        <b-button @click="prepareCheckout">Prepare the checkout</b-button>
        <b-button @click="createPaymentForm">Create the payment form</b-button>
      </div>
      <b-field label="CheckoutId">
        <b-input v-model="checkoutId"></b-input>
      </b-field>
      <form
        action="/placanje-status"
        class="paymentWidgets"
        data-brands="VISA MASTER MAESTRO"
      ></form>
      <b-button @click="getPaymentStatus">Get the payment status</b-button>
    </div>
  </section>
</template>

<script>
import PaymentService from '../services/PlacanjeService'
export default {
  data() {
    return {
      checkoutId: null,
      iznos: 100,
      valuta: 'RSD'
    }
  },
  methods: {
    prepareCheckout() {
      //console.log('test')
      PaymentService.prepareCheckout(100).then(response => {
        // buildNumber: "7dacfff9258eb8531953cdbf10fdb2b2ebe821cc@2020-09-29 08:03:45 +0000"
        // id: "2A51CD64DEAE318B92DAE90575851CBD.uat01-vm-tx04"
        // ndc: "2A51CD64DEAE318B92DAE90575851CBD.uat01-vm-tx04"
        // result: {code: "000.200.100", description: "successfully created checkout"}
        // timestamp: "2020-09-29 09:38:54+0000"

        console.log(response.data)
        this.checkoutId = response.data.id
      })
    },
    createPaymentForm() {
      let paymentWidgetsScript = document.createElement('script')
      paymentWidgetsScript.setAttribute(
        'src',
        'https://test.oppwa.com/v1/paymentWidgets.js?checkoutId=' +
          this.checkoutId
      )
      document.head.appendChild(paymentWidgetsScript)
    },
    getPaymentStatus() {
      PaymentService.getPaymentStatus(this.checkoutId).then(response => {
        console.log(response.data)
      })
    }
  }
}
</script>

<style></style>
